import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Skeleton from '@mui/material/Skeleton';
import { jsx, jsxs } from 'react/jsx-runtime';

// src/til/post-detail-page/metadata-skeleton.tsx
var SkeletonPostMetadata = (props) => /* @__PURE__ */ jsx(Card, { sx: props.sx, "aria-busy": true, children: /* @__PURE__ */ jsxs(CardContent, { children: [
  /* @__PURE__ */ jsx(Skeleton, { variant: "text", width: "80%", height: 50, sx: { mb: 2 } }),
  /* @__PURE__ */ jsx(Skeleton, { variant: "text", width: "20%", height: 30 })
] }) });

export { SkeletonPostMetadata };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-AIFRNLQC.mjs.map